// extracted by mini-css-extract-plugin
module.exports = {"heading":"TestPage_heading__385vr","list":"TestPage_list__ZeDie","item":"TestPage_item__1Z1Hf"};